import { Space, Typography } from 'antd';
import { FC, ReactNode } from 'react';

import * as Styled from './profile-drawer-item.style';

interface ProfileDrawerItemProps {
  title: string;
  description?: string;
  icon?: ReactNode;
  onClick?: () => void;
  suffixIcon?: ReactNode;
  color: string;
}

const ProfileDrawerItem: FC<ProfileDrawerItemProps> = ({
  title,
  description,
  icon,
  onClick,
  suffixIcon,
  color,
}) => {
  return (
    <Styled.FlexWrapper
      onClick={onClick}
      color={color}
      data-testid="profile-drawer-item"
    >
      <Styled.IconWrapper>{icon}</Styled.IconWrapper>
      <Styled.TextWrapper>
        <Space direction="vertical" size={4}>
          <Styled.Title level={5} data-testid="profile-drawer-item-title">
            {title}
          </Styled.Title>
          {description && (
            <Typography.Text type="secondary">{description}</Typography.Text>
          )}
        </Space>
        {suffixIcon && <Styled.IconWrapper>{suffixIcon}</Styled.IconWrapper>}
      </Styled.TextWrapper>
    </Styled.FlexWrapper>
  );
};

export { ProfileDrawerItem };
